
































import { mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'

import { ApiService, UserService } from '@/services'
import validationRules from '@/utils/validation'

export default {
  name: 'Social',

  directives: {
    mask,
  },

  data() {
    return {
      nameRules: validationRules.nameRules,
      phoneRules: validationRules.phoneRules,
      emailRules: validationRules.emailRules,
      savePersonalInfoLoading: false,
      sendMagicLinkEmailLoading: false,
      sendMagicLinkEmailDisabled: true,
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),
  },

  watch: {
    'user.email': function (email) {
      if (this.user.email !== UserService.getEmail()) {
        this.sendMagicLinkEmailDisabled = false
        return
      }

      this.sendMagicLinkEmailDisabled = true
    },
  },

  methods: {
    savePersonalInfo() {
      if (!this.$refs.personalInformationForm.validate()) return

      this.savePersonalInfoLoading = true
      const first_name = this.user.first_name ? this.user.first_name.trim() : ''
      const last_name = this.user.last_name ? this.user.last_name.trim() : ''
      const phone = this.user.phone ? this.user.phone.replace(/[()\s-]/g, '') : ''

      UserService.setPersonalInfo(this.user.first_name, this.user.last_name, this.user.phone).then(() => {
        this.savePersonalInfoLoading = false
        this.$toast.success('Personal information saved')
      })
    },

    sendMagicLinkEmail() {
      if (!this.$refs.emailForm.validate()) return

      this.sendMagicLinkEmailLoading = true
      const userId = UserService.getUserId()
      const email = this.user.email ? this.user.email.trim() : ''

      ApiService.post(`auth/verify/${userId}`, {
        email: email,
        redirect: this.$router.currentRoute.path,
      }).then((response) => {
        this.sendMagicLinkEmailLoading = false
        this.sendMagicLinkEmailDisabled = true

        this.$router.push('/auth/verify')
      })
    },
  },
}
